module.exports = __webpack_public_path__ + "img/pay-success.dd0f3ac2.png";